
const digest = 'd4f9971bdaac136be71d5189badbcc605c5b9bc653e73679a6bd4693153409d7';
const classes = {"wrapper2":"_wrapper2_rbxbc_1"};
const css = `._wrapper2_rbxbc_1 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  